import Axios from 'axios';
import { rootModule } from './store/storeContext';
import { BACKEND_URL } from './config';

const instance = Axios.create();

//Adding language to all outbound requests:
instance.interceptors.request.use((request) => {
    const language = rootModule.localization.locale;
    if (language) {
        request.headers['Language'] = language;
    }
    return request;
});

//Request error handler middleware:
instance.interceptors.response.use(
    (response) => {
        const contentType = response.headers['content-type'];
        if (typeof response.data === 'string' && contentType?.includes('json')) {
            // JSON is broken. Fix vertical tabs and parse back to JSON.
            response.data = JSON.parse(response.data.replace(/\\v/g, '\\u000B'));
        }
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        if (error.response && error.response.status === 401 && error.response.headers?.['token-expired'] === 'true') {
            try {
                await instance.post(BACKEND_URL + 'auth/refresh'); // refresh token endpoint
                return instance(originalRequest); // retry original request
            } catch (refreshError) {
                throw error.response;
            }
        }
        throw error.response;
    },
);

export default instance;
